import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Award } from "lucide-react";

export function ChampionBadge({ editable = false }) {
  const [c, setC] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/care-home/champion").then((r) => setC(r.data)).catch(() => {}); }, []);
  if (!c) return null;
  if (!c.champion_name) {
    if (!editable) return null;
    return (
      <button type="button" data-testid="champion-badge-empty" onClick={() => nav("/app/profile")} className="mb-6 w-full text-left rounded-2xl border border-dashed border-coral/50 bg-coral/5 px-4 py-3 flex items-center gap-3 hover:bg-coral/10 transition-colors">
        <Award className="h-5 w-5 text-coral" /><span className="text-sm text-brand"><b>Who is your Oral Champion?</b> Add their name and photo so the whole team knows who to go to.</span>
      </button>
    );
  }
  return (
    <div data-testid="champion-badge" className="mb-6 rounded-2xl bg-brand text-white px-4 py-3 flex items-center gap-4">
      <div className="h-12 w-12 rounded-full bg-white/15 overflow-hidden grid place-items-center shrink-0">
        {c.champion_photo_url ? <img src={c.champion_photo_url} alt={c.champion_name} className="h-full w-full object-cover" /> : <Award className="h-6 w-6 text-coral" />}
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[11px] uppercase tracking-wider text-coral font-semibold">Our Oral Champion</div>
        <div className="font-heading font-bold truncate">{c.champion_name}<span className="font-body font-normal text-white/70 text-sm">{c.champion_role ? ` · ${c.champion_role}` : ""}</span></div>
      </div>
      <div className="hidden sm:block text-xs text-white/70 text-right">Go-to person for any mouth care question in our home</div>
      {editable && <button type="button" data-testid="champion-badge-edit" onClick={() => nav("/app/profile")} className="text-xs underline text-white/80 hover:text-white">Edit</button>}
    </div>
  );
}
